import { useState } from "react";

// Selección múltiple para la vista de tarjetas (independiente de la
// selección interna que maneja MaterialReactTable en la vista de tabla).
const useSeleccionPedidos = () => {
  const [modoSeleccion, setModoSeleccion] = useState(false);
  const [seleccionados, setSeleccionados] = useState(new Set());

  const toggleSeleccionado = (id) => {
    setSeleccionados((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  const limpiarSeleccion = () => {
    setSeleccionados(new Set());
    setModoSeleccion(false);
  };

  // Selecciona el grupo completo si falta algún id por marcar; si ya estaban
  // todos marcados, los desmarca a todos (toggle "seleccionar sucursal").
  const alternarGrupo = (ids) => {
    setSeleccionados((prev) => {
      const next = new Set(prev);
      const todosMarcados = ids.every((id) => next.has(id));
      ids.forEach((id) => (todosMarcados ? next.delete(id) : next.add(id)));
      return next;
    });
  };

  return {
    modoSeleccion,
    setModoSeleccion,
    seleccionados,
    toggleSeleccionado,
    limpiarSeleccion,
    alternarGrupo,
  };
};

export default useSeleccionPedidos;
